<template>
  <div id="earnings">
    <van-row class="earnings_log">
      <van-col span="24" class="earnings_log_top">
        <van-col span="12" @click="showPopup" class="earnings_log_top_left">
          2020-06
          <van-icon name="arrow-down" />
        </van-col>
        <van-col span="12" class="earnings_log_center">
          {{ $t('column.total_revenue') }}:1552525
        </van-col>
      </van-col>
      <van-col span="24">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('other.there_is_no_more')"
          @load="onLoad"
          :offset="10"
        >
          <van-cell v-for="t in list" :key="t.id">
            <van-col span="24" class="earnings_log_type">
              <van-col span="18">
                <van-col span="24" class="earnings_log_type_name">{{ t.nick_name }} {{$t('other.reward')}} {{ t.prop_name }}</van-col>
                <van-col span="24" class="earnings_log_type_time">{{ t.time }}</van-col>
              </van-col>
              <van-col span="6" class="earnings_log_type_money"> + {{ t.total_ticket }} </van-col>
            </van-col>
          </van-cell>
        </van-list>
        <div class="no-data" v-if="!this.list">
          <van-icon name="underway-o" /> <br/> {{ $t('other.no_record')}}
        </div>
      </van-col>
    </van-row>
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }" >
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :title="$t('column.select_month_and_year')"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="check_time_btn"
        @change="check_time"
        :formatter="formatter"
      />
    </van-popup>

  </div>
</template>

<script>

  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  import { Popup, DatetimePicker, PullRefresh } from 'vant'
  export default {
    data() {
      return {
        show: false,
        isLoading: false,
        finished: false,
        loading: false,
        minDate: new Date(2019, 0, 1),
        maxDate: new Date(2025, 10, 1),
        currentDate: new Date(),
        year: 2018,
        month: 5,
        new_year: 0,
        new_month: 0,
        page: 1,
        list:[]
      }
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.earnings')
    },
    components: {
      [Popup.name]: Popup,
      [DatetimePicker.name]: DatetimePicker,
      [PullRefresh.name]: PullRefresh
    },
    methods: {
      check_time (picker, value, colum) {
        let startTime = picker.getValues()
        this.new_year = startTime[0]
        this.new_month = startTime[1]
      },
      check_time_btn () {
        this.year = this.new_year
        this.month = this.new_month

      },
      onLoad() {
        this.page++
        this.convert()
      },
      formatter(type, val) {
        if (type === 'year') {
          return val
        } else if (type === 'month') {
          return val
        }
        return val
      },
      showPopup() {
        this.show = true
      },
      convert: function() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_center&act=earnings_log", {
          params : {
            token: token,
            year: this.year,
            month: this.month,
            page: this.page
          }
        }).then(res =>{
          console.log(res.data)
          this.loading = false
          this.list = res.data.list
          let rows = res.data.rows; //请求返回当页的列表


          this.total = res.data.total;

          if (rows == null || rows.length === 0) {
            // 加载结束
            if (this.page > 1) {
              this.finished = true
            }

            return
          }
          // 将新数据与老数据进行合并
          this.itemList = this.itemList.concat(rows)
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.itemList.length >= this.total) {
            this.finished = true
          }
        })
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/earnings.vue